// Literal copy of docs/design/2026-08-26-design-token-contract.md. Keep the two in sync by hand,
// same relationship schemas/config-version.schema.json has to src/types.ts. This is the base
// stylesheet injected into the embed's Shadow DOM root (ADR-002): every color, font, radius,
// spacing, layout, and motion value the component renders resolves from a token declared here, so
// re-theming (a brand refresh, or the future LU project, per ADR-009) is a new token block, not a
// code change.

export const tokenStylesheet = `
:host {
  --bfc-color-bg: #FBF7F3;
  --bfc-color-surface: #FFFFFF;
  --bfc-color-text: #1F2B44;
  --bfc-color-text-muted: #696969;
  --bfc-color-dark: #252525;
  --bfc-color-accent: #0B5C4D;
  --bfc-color-cta: #CC7722;
  --bfc-color-cta-hover: #B8691E;
  --bfc-color-cta-end: #E8AF47;
  --bfc-color-cta-end-hover: #D69D38;
  --bfc-gradient-cta: linear-gradient(to left, var(--bfc-color-cta-end), var(--bfc-color-cta));
  --bfc-gradient-cta-hover: linear-gradient(to left, var(--bfc-color-cta-end-hover), var(--bfc-color-cta-hover));
  --bfc-color-eyebrow: #A9743F;
  --bfc-color-avatar-bg: #1F3A2E;
  --bfc-color-scrim: rgba(20, 22, 30, 0.88);
  --bfc-color-muted-bg: #AEAEAE;
  --bfc-color-muted-text: #696969;
  --bfc-color-border: #E8E1D9;
  --bfc-color-focus-ring: #0B5C4D;

  --bfc-color-warning: #CC7722;
  --bfc-color-warning-50: #CC772240;
  --bfc-color-error: #D32F2F;
  --bfc-color-error-50: #D32F2F40;
  --bfc-color-success: #0B5C4D;
  --bfc-color-success-50: #0B5C4D40;

  --bfc-font-family: "DM Sans", -apple-system, BlinkMacSystemFont, sans-serif;
  --bfc-font-weight-regular: 400;
  --bfc-font-weight-bold: 700;
  --bfc-font-weight-black: 900;
  --bfc-font-size-body: 16px;
  --bfc-font-size-question: 22px;
  --bfc-font-size-heading: 28px;
  --bfc-font-size-label: 14px;
  --bfc-font-size-eyebrow: 12px;
  --bfc-letter-spacing-label: 0.04em;
  --bfc-letter-spacing-eyebrow: 0.1em;

  --bfc-radius-sm: 3px;
  --bfc-radius-md: 8px;
  --bfc-radius-lg: 20px;
  --bfc-radius-button: 6px;
  --bfc-space-xs: 4px;
  --bfc-space-sm: 8px;
  --bfc-space-md: 16px;
  --bfc-space-lg: 32px;
  --bfc-space-xl: 48px;

  --bfc-z-overlay: 2147483000;
  --bfc-overlay-max-width: 520px;
  --bfc-shadow-card: 0 1px 3px rgba(31, 43, 68, 0.08), 0 4px 12px rgba(31, 43, 68, 0.06);
  --bfc-shadow-panel: 0 24px 64px rgba(0, 0, 0, 0.45);
  --bfc-avatar-size: 96px;

  --bfc-motion-duration-fast: 120ms;
  --bfc-motion-duration-base: 220ms;
  --bfc-motion-duration-slow: 400ms;
  --bfc-motion-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --bfc-motion-stagger-step: 40ms;

  all: initial;
  display: contents;
  font-family: var(--bfc-font-family);
  color: var(--bfc-color-text);
}

@media (prefers-reduced-motion: reduce) {
  :host {
    --bfc-motion-duration-fast: 1ms;
    --bfc-motion-duration-base: 1ms;
    --bfc-motion-duration-slow: 1ms;
    --bfc-motion-stagger-step: 0ms;
  }
}

*, *::before, *::after {
  box-sizing: border-box;
}
`;
